import React, { FC } from 'react';
import type { UserImageCategoryViewProps } from './UserImageCategoryView.types';

export const UserImageCategoryView: FC<UserImageCategoryViewProps> = ({ category }) => (
  <div data-hook={`custom-category-view-${category.id}`}>We are user image! Implement us!</div>
);
